/*esto fue agregado 16hs 4-12-25 la ultima actualizacion*/
import React, { createContext, useState, useContext } from 'react';
import { initialUserData, initialSavedCards } from '../data/initialData';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  /* New state for cards */
  const [cards, setCards] = useState(initialSavedCards || []);

  const loginWithPredefined = () => {
    setUser(initialUserData);
    setIsAuthenticated(true);
    localStorage.setItem('cafeMoctezumaUser', JSON.stringify(initialUserData));
  };

  const login = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('cafeMoctezumaUser', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    setPhoneNumber('');
    localStorage.removeItem('cafeMoctezumaUser');
  };

  const setPhone = (phone) => {
    setPhoneNumber(phone);
  };

  const addCard = (newCard) => {
    setCards(prevCards => [...prevCards, { ...newCard, id: Date.now() }]);
  };

  const removeCard = (cardId) => {
    setCards(prevCards => prevCards.filter(card => card.id !== cardId));
  };

  const value = {
    user,
    isAuthenticated,
    phoneNumber,
    login,
    logout,
    setPhone,
    loginWithPredefined,
    cards,
    addCard,
    removeCard
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};